import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../store'

const initialState = {
  clave: 'clave',
}

/**
 * Estado de seleccion dentro de ajustes/perfil.
 *
 * `clave` identifica la opcion activa del panel para renderizar la configuracion
 * seleccionada sin depender de estado local disperso entre componentes.
 */
export const perfilSlice = createSlice({
  name: 'opcionesPerfil',
  initialState,
  reducers: {
    setOpcion: (state, action: PayloadAction<string>) => ({
      ...state,
      clave: action.payload,
    }),
    resetOption: () => ({
      ...initialState,
    }),
  },
})

export const { setOpcion, resetOption } = perfilSlice.actions

export const claveActual = (state: RootState) => state.opcionesPerfil.clave
